module.exports = __webpack_public_path__ + "static/media/royal_guard_armor.ff44cc58.png";